import dayjs from 'dayjs';
import 'dayjs/locale/nl';

dayjs.locale('nl');

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function toJSON() {
    return dayjs(this).format('YYYY-MM-DDTHH:mm:ssZ');
};

const formatDate = (date: string | Date) => dayjs(date).format('DD-MM-YYYY');

const formatTime = (date: string | Date) => dayjs(date).format('HH:mm');

const formatDateTime = (date: string | Date) => dayjs(date).format('DD-MM-YYYY HH:mm');

const formatDayMonth = (date: string | Date) => dayjs(date).format('DD MMMM');

export {
    formatDate,
    formatTime,
    formatDateTime,
    formatDayMonth,
};
